import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFemale$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFemale extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ebbd065950e24ec57b4dc1b80d30c2db493dc9a0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '416800604ce412f332dc168c3bd2842c4e809c0d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b6fe7bbc8ac2232b73e69654faa38788f73459f1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.5 16h-2.8v-3.1c2.5-.3 4.3-2.4 4.3-4.9 0-2.8-2.2-5-5-5S6 5.2 6 8c0 2.5 1.8 4.6 4.2 4.9V16H7.5c-.3 0-.5.2-.5.5v.5c0 .3.2.5.5.5h2.8v2c0 .3.2.5.5.5h.5c.3 0 .5-.2.5-.5v-2h2.8c.3 0 .5-.2.5-.5v-.5c-.1-.3-.3-.5-.6-.5m-7-8c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5S7.5 9.9 7.5 8", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-female", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-female"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-female":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFemale$1);
            }
            break;
    } });
}

const CosmosIconFemale = CosmosIconFemale$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFemale, defineCustomElement };
